import {
  Field,
  InputGroup,
  InputGroupAddon,
} from '@noorden-insurtech/alba-design-system';
import { SearchIcon } from 'lucide-react';
import type { ChangeEvent, Ref } from 'react';

interface SearchFilterFieldProps {
  placeholder?: string;
  className?: string;
  inputRef?: Ref<HTMLInputElement>;
}

type SearchFilterFieldValueProps = {
  value: unknown;
  onChange: (_value: unknown) => void;
  name?: string;
  type?: 'string' | 'integer';
};

export function SearchFilterField({
  value,
  onChange,
  placeholder = 'Buscar...',
  className = '',
  inputRef,
}: SearchFilterFieldProps & SearchFilterFieldValueProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <InputGroup className={className}>
      <InputGroupAddon align='inline-start'>
        <SearchIcon className='h-5 w-5' strokeWidth={2} />
      </InputGroupAddon>
      <Field.Input
        className='!border-0 !bg-transparent overflow-hidden text-ellipsis whitespace-nowrap [&::placeholder]:overflow-hidden [&::placeholder]:text-ellipsis [&::placeholder]:whitespace-nowrap'
        data-slot='input-group-control'
        placeholder={placeholder}
        type='text'
        value={String(value || '')}
        onChange={handleChange}
        onKeyDown={e => {
          e.stopPropagation();
        }}
        ref={inputRef}
      />
    </InputGroup>
  );
}
